import * as React from 'react';
import classnames from 'classnames';
import Flex, { Props as FlexProps } from '../Flex/Flex';

export interface Props extends FlexProps {
  /**
   * Flag that controls if the enabled
   * state for controlling the child Visibility state.
   */
  enabled?: boolean;
}

/** Container that controls the visibility state on hover. */
const VisibilityContainer: React.FunctionComponent<Props> = (props: Props) => {
  const { className, enabled, ...rest } = props;
  const classes = classnames(className, 'Visibility__container', {
    'Visibility__container--enabled': enabled,
  });

  return (
    <Flex className={ classes } { ...rest } />
  );
};

VisibilityContainer.defaultProps = {
  enabled: true,
};

export default VisibilityContainer;
